import React, { useState } from "react";
import * as Styled from "./styles";

export interface SideButtonProps {
  isAnimated: boolean;
  backgroundColor?: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  title?: string;
  isBottomPlacement?: boolean,
}

const SideButton = ({
  backgroundColor,
  icon,
  onClick,
  isAnimated,
  title,
  isBottomPlacement,
}: SideButtonProps) => {
  const [isSpinning, setIsSpinning] = useState(false);

  const handleClick = () => {
    setIsSpinning(isAnimated);
    onClick();
    setTimeout(() => {
      setIsSpinning(false);
    }, 1500);
  };
  return (
    <Styled.IFrameButton
      isBottomPlacement={isBottomPlacement}
      onClick={handleClick}
      backgroundColor={backgroundColor}
      isSpinning={isSpinning}
      hasText={Boolean(title)}
      variant="contained"
    >
      {icon || (
        <Styled.IFrameButtonTitle isBottomPlacement={isBottomPlacement}>
          {title}
        </Styled.IFrameButtonTitle>
      )}
    </Styled.IFrameButton>
  );
};

export default SideButton;
